<template lang='pug'>
layout#page-create-company
  h2 Temp Playground

  zerox-instant
</template>

<script>
import zeroxInstant from '../components/zerox-instant.vue';

const components = {
  zeroxInstant,
};

export default {
  components,
  metaInfo: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
  beforeDestroy() {
  },
};
</script>
